import {Injectable} from "@angular/core";
import {Observable, throwError} from "rxjs";
import {HttpEvent} from "@angular/common/http";
import {CasaNativeApiV3} from "../../casa-native-api";
import {
  CountryDefinition,
  V3Address,
  V3ContactEntry,
  V3ContactEntryDetails,
  V3Person,
  V3PersonalSensitiveDetails,
  V3PersonDetails,
  V3Settings,
} from "../../../../model/v3/people";
import {V3FileItem} from "../../../../model/v3/file";
import {
  SchoolStudentStatus,
  V3School,
  V3SchoolTeacher,
  V3Student,
  V3Teacher,
} from "../../../../model/v3/schools";
import {Page, Pageable} from "../../../../../utils/pageable";

@Injectable({
  providedIn: 'root',
})
export class UnsupportedCasaNativeApi implements CasaNativeApiV3 {
  findTeachers(schoolId: number, term?: string | null, productCode?: string | null, pageable?: Pageable | null): Observable<Page<V3Teacher>> {
    return this.notSupported();
  }

  getTeachers(
    schoolId?: number | null,
    personId?: number | null,
    email?: string | null,
    teacherIds?: number[] | null,
    pageable?: Pageable | null
  ): Observable<Page<V3SchoolTeacher>> {
    return this.notSupported();
  }

  private notSupported<T>(): Observable<T> {
    return throwError(() => new Error('Not supported'));
  }

  uploadFile(file: File): Observable<HttpEvent<any>> {
    return this.notSupported();
  }

  getPerson(personId: number): Observable<V3Person> {
    return this.notSupported();
  }

  updatePerson(personId: number, details: V3PersonDetails): Observable<V3Person> {
    return this.notSupported();
  }

  deletePerson(personId: number): Observable<void> {
    return this.notSupported();
  }

  listContacts(personId: number): Observable<V3ContactEntry[]> {
    return this.notSupported();
  }

  createContact(personId: number, contact: V3ContactEntryDetails): Observable<void> {
    return this.notSupported();
  }

  updateContact(personId: number, contactId: number, contact: V3ContactEntryDetails): Observable<void> {
    return this.notSupported();
  }

  getAddress(personId: number): Observable<V3Address> {
    return this.notSupported();
  }

  updateAddress(personId: number, address: V3Address): Observable<void> {
    return this.notSupported();
  }

  getSensitive(personId: number): Observable<V3PersonalSensitiveDetails> {
    return this.notSupported();
  }

  updateSensitive(personId: number, sensitive: V3PersonalSensitiveDetails): Observable<void> {
    return this.notSupported();
  }

  getPhoto(personId: number): Observable<V3FileItem> {
    return this.notSupported();
  }

  updatePhoto(personId: number, file: V3FileItem): Observable<void> {
    return this.notSupported();
  }

  getSettings(personId: number): Observable<V3Settings> {
    return this.notSupported();
  }

  updateSettings(personId: number, settings: V3Settings): Observable<void> {
    return this.notSupported();
  }

  listCountries(): Observable<CountryDefinition[]> {
    return this.notSupported();
  }

  getSchool(schoolId: number): Observable<V3School> {
    return this.notSupported();
  }

  getStudents(
    schoolId: number,
    term?: string | null,
    status?: SchoolStudentStatus[] | null,
    expiry?: Date | string | null,
    pageable?: Pageable,
  ): Observable<Page<V3Student>> {
    return this.notSupported();
  }

  getStudent(schoolId: number, studentId: number): Observable<V3Student> {
    return this.notSupported();
  }

  getTeacher(schoolId: number, teacherId: number): Observable<V3Teacher> {
    return this.notSupported();
  }

  isImplemented(): boolean {
    return false;
  }

  supportsFileSending(): boolean {
    return false;
  }

  isSupportsProfileEdit(): Boolean {
    return false;
  }
}
